import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const chipCode = `<ChipSet header="Chips">
    <Chip onRemoveIconInteraction={() => console.log("Remove icon clicked.")} id="chip">Chip</Chip>
</ChipSet>`;

const chipDemo = {
    code: chipCode
};

export const ChipDemo: FunctionComponent = () => {
    return (
        <Demo demo={chipDemo}>
            <ComponentProps componentName="Chip" />
            <ComponentProps componentName="ChipSet" />
        </Demo>
    );
};
